import { z } from 'zod';

import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';

// Acquisition method
// - Deed in lieu
// - Foreclosure sale held

export const ReoRecord = z.object({
  processedDate: zodJSPlainDate,
  createdAt: zodJSInstantDate,
  updatedAt: zodJSInstantDate,
});
export type ReoRecord = z.infer<typeof ReoRecord>;

export const ReoRecordInput = ReoRecord.pick({
  processedDate: true,
});
export type ReoRecordInput = z.infer<typeof ReoRecordInput>;
